import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import useSetHeroImg from '../../../hooks/useSetHeroImg';
import styles from './heroHomeTemplate.module.scss';
import trackHeapEvent from '../../../services/helpers/trackHeapEvent';
import HeroHomePrequalCard from '../../heroHomePrequal/prequalCard/heroHomePrequalCard';
import HeroHomePrequal from '../../heroHomePrequal/prequaldefault/heroHomePrequal';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import SmartImage from '../../smartImage/smartImage';

function HeroHomeTemplateDefault({
  title = '',
  titleBlue,
  heroDesc = '',
  signatureTitle = '',
  signatureSubTitle = '',
  image = null,
  mobImage = null,
  cta = null,
  signatureBgImage = null,
  signatureImage = null,
  signatureMobileImage = null,
  prequalItems = null,
}) {
  const heroSignatureTrack = (analyticsKey) => {
    trackHeapEvent(
      {
        Name: 'Home Page - Hero What Our Member Say',
        CTA: analyticsKey,
      },
      'CMS_Unification'
    );
  };
  const [docked, setDocked] = useState(false);
  const { width } = useWindowDimensions();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (width < 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [width]);
  useEffect(() => {
    const isDocked =
      window.document.documentElement.scrollTop >= 0 || window.scrollY >= 0;
    setDocked(isDocked);
  }, []);

  const heroImg = useSetHeroImg(image, mobImage, width);
  const heroSigImage = useSetHeroImg(
    signatureImage,
    signatureMobileImage,
    width
  );
  const displayPrequal = () => {
    if (prequalItems?.prequalType === 'Home Card' && !isMobile) {
      return <HeroHomePrequalCard {...prequalItems} />;
    }
    if (prequalItems?.prequalType === 'Home Card' && isMobile) return null;
    return <HeroHomePrequal {...prequalItems} />;
  };

  return (
    <>
      <section className={styles.heroPrequalWithMultipleImages}>
        <div className={styles.sectionContainer}>
          <div
            className={`${styles.heroPrequalWithMultipleImagesLeft} ${
              prequalItems?.prequalType === 'Home Card'
                ? `${styles.heroPrequalWithMultipleImagesForCard}`
                : ''
            }`}
          >
            <div className={styles.heroHeader}>
              {title || titleBlue ? (
                <h1
                  className={`${styles.headerTitleScroll} ${
                    docked && styles.headerTitleScrollDocked
                  }`}
                >
                  {title && title} {titleBlue && <strong>{titleBlue}</strong>}
                </h1>
              ) : null}
              {heroDesc && (
                <div
                  className={`${styles.headerDescScroll} ${
                    docked && styles.headerDescScrollDocked
                  }`}
                >
                  {parse(heroDesc)}
                </div>
              )}
            </div>
            {prequalItems && displayPrequal()}
          </div>
          {heroImg && (
            <div className={styles.heroPrequalWithMultipleImagesCenter}>
              <div className={styles.heroClipImage}>
                <SmartImage
                  src={heroImg}
                  alt={heroImg?.alt}
                  loading="lazy"
                  height={heroImg?.height}
                  width={heroImg?.width}
                />
              </div>
            </div>
          )}
          <div
            id="heroPrequalWithMultipleImagesRight"
            className={styles.heroPrequalWithMultipleImagesRight}
          >
            {signatureBgImage && signatureBgImage.length > 0
              ? parse(
                  `<style>
            #heroPrequalWithMultipleImagesRight{
                  background-image: url('${signatureBgImage.src}');
                }
            </style>`
                    .trim()
                    .replace(/\s{2,}/g, '')
                )
              : null}
            <div className={styles.heroSignature}>
              {heroSigImage && (
                <SmartImage
                  src={heroSigImage}
                  alt={heroSigImage?.alt}
                  loading="lazy"
                  height={heroSigImage.height}
                  width={heroSigImage?.width}
                />
              )}
              {signatureTitle && <h3>{signatureTitle}</h3>}
              {signatureSubTitle && <h5>{signatureSubTitle}</h5>}
              {cta && (
                <a
                  href={cta.link}
                  data-testid="cta-btn"
                  onClick={() => heroSignatureTrack(cta.heapEventKey)}
                >
                  {cta.label}
                </a>
              )}
            </div>
          </div>
        </div>
      </section>
      {isMobile && prequalItems?.prequalType === 'Home Card' && (
        <div className={styles.heroHometemplatePrequalSectionForCardMobile}>
          <div className={styles.heroHomePrequalMobile}>
            <HeroHomePrequalCard {...prequalItems} />
          </div>
        </div>
      )}
    </>
  );
}

HeroHomeTemplateDefault.propTypes = {
  title: PropTypes.string,
  heroDesc: PropTypes.string,
  signatureTitle: PropTypes.string,
  signatureSubTitle: PropTypes.string,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
  }),
  mobImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
  }),
  cta: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string,
    heapEventKey: PropTypes.string,
  }),
  signatureBgImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
  }),
  signatureImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
  }),
  signatureMobileImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
  }),
  prequalItems: PropTypes.object,
};

export default HeroHomeTemplateDefault;
